/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import { useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
/**
 * Custom hook for managing form errors and error indicators in deployment form tabs
 *
 * @returns {Object} An object containing the following:
 *   @property {Array} errorFields - Array tracking form fields with validation errors
 *   @property {Set} tabsWithErrors - Set of tab keys that contain validation errors
 *   @property {Function} generateTabLabel - Generates a tab label with error indicator if needed
 *   @property {Function} markAsErroneous - Updates the error state of a specific tab
 *   @property {Function} setErrorFields - Updates the errorFields state
 *
 */
export const useDeploymentFormErrors = () => {
  // State variable to know if there are form errors when the user submits the form
  // we need that to be an array, in order to mark new fields with errors when submitting the form multiple times
  const [errorFields, setErrorFields] = useState([]);
  const [tabsWithErrors, setTabsWithErrors] = useState(new Set());

  const generateTabLabel = (label='', tabKey) => {
    let tabKeyArr = Array.isArray(tabKey) ? tabKey : [tabKey];

    return tabKeyArr.some(tabKey => tabsWithErrors.has(tabKey))
      ? <span className="text-error"><ExclamationCircleOutlined className="mr-1" />{label}</span>
      : label;
  };

  const markAsErroneous = (isErroneous, tabKey) => {
    if (!isErroneous) {
      if (tabsWithErrors.has(tabKey)) {
        const curSet = new Set(tabsWithErrors);
        curSet.delete(tabKey);
        setTabsWithErrors(new Set(curSet));
      }
      return;
    }
    setTabsWithErrors(prevSet => new Set([...prevSet, tabKey]));
  };

  return {
    errorFields,
    tabsWithErrors,
    generateTabLabel,
    markAsErroneous,
    setErrorFields
  };
};
